module.exports = __webpack_public_path__ + "static/6-spamemail-1978-f130cc08e2bd83925be9ea2b70dc5714.jpg";